import { api, errorBanner, loadingBanner } from "../api.js";
import { replaceQuery } from "../router.js";
import { escapeHtml } from "../format.js";
import { renderPagination, bindPagination } from "../components/pagination.js";
import { renderHouseTabs, bindHouseTabs } from "../components/segmented.js";
import { renderFilterFooter, isDirty } from "../components/filterbar.js";
import { renderPropositionCard } from "../components/propcard.js";

const TYPES = ["PL", "PLP", "PEC", "MPV", "PDL", "PLV", "PLS", "PLC", "PRC", "PRS", "PDS", "REQ", "INC", "RIC"];
const DEFAULTS = { house: "", type: "", subject: "", year: "", has_votes: false };

export async function renderSearch({ root, query, isCurrent }) {
  document.title = "Busca · Como Vota";
  const state = {
    q: query.q || "",
    house: query.house || "",
    type: query.type || "",
    subject: query.subject || "",
    year: query.year || "",
    has_votes: query.has_votes === "1" || query.has_votes === "true",
    page: Number(query.page || 1),
  };
  let subjects = [];
  try {
    subjects = await api.subjects();
  } catch {
    subjects = [];
  }
  if (!isCurrent()) return;

  root.innerHTML = `
    <section class="detail detail--wide">
      <div class="page-head">
        <span class="eyebrow-pill">Propostas</span>
        <h1 class="page-title">Busca</h1>
        <p class="muted">Pesquise por palavras da ementa, número da proposição ou tema.</p>
      </div>
      <form class="filters" data-form>
        <div class="searchbar">
          <input type="search" name="q" value="${escapeHtml(state.q)}" placeholder="Ex.: reforma tributária, PL 2338/2023" aria-label="Termo de busca" />
          <button type="submit" class="btn btn--primary">Buscar</button>
        </div>
        <div class="filters__row">
          ${renderHouseTabs(state.house)}
          <label>Tipo
            <select name="type">
              <option value="">Todos</option>
              ${TYPES.map((t) => `<option value="${t}" ${state.type === t ? "selected" : ""}>${t}</option>`).join("")}
            </select>
          </label>
          <label>Tema
            <select name="subject">
              <option value="">Todos</option>
              ${subjects
                .map(
                  (s) =>
                    `<option value="${escapeHtml(s.slug)}" ${state.subject === s.slug ? "selected" : ""}>${escapeHtml(s.label)} (${s.count})</option>`,
                )
                .join("")}
            </select>
          </label>
          <label>Ano
            <input type="number" name="year" min="1900" max="2100" value="${escapeHtml(state.year)}" placeholder="AAAA" />
          </label>
          <label class="check" title="Aplicado apenas quando não há termo de busca"><input type="checkbox" name="has_votes" ${state.has_votes ? "checked" : ""} /> Só com votações</label>
        </div>
        <div class="filters__foot" data-foot></div>
      </form>
      <div data-results>${loadingBanner("Buscando…")}</div>
    </section>`;

  const form = root.querySelector("[data-form]");
  const foot = root.querySelector("[data-foot]");
  const results = root.querySelector("[data-results]");

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    readForm();
    state.page = 1;
    load();
  });
  form.querySelectorAll("select, input[type=checkbox]").forEach((el) =>
    el.addEventListener("change", () => {
      readForm();
      state.page = 1;
      load();
    }),
  );
  bindHouseTabs(root, (house) => {
    readForm();
    state.house = house;
    state.page = 1;
    load();
  });

  function readForm() {
    state.q = form.q.value.trim();
    state.type = form.type.value;
    state.subject = form.subject.value;
    state.year = form.year.value;
    state.has_votes = form.has_votes.checked;
  }

  function footer(total, loading) {
    foot.innerHTML = renderFilterFooter({
      total,
      loading,
      noun: "resultado",
      nounPlural: "resultados",
      hasFilters: isDirty(state, DEFAULTS),
      clearHref: state.q ? `/busca?q=${encodeURIComponent(state.q)}` : "/busca",
    });
  }

  async function load() {
    replaceQuery({ ...state, has_votes: state.has_votes ? "1" : "" });
    results.innerHTML = loadingBanner("Buscando…");
    footer(null, true);
    const params = {
      q: state.q,
      house: state.house,
      type: state.type,
      subject: state.subject,
      year: state.year,
      has_votes: state.has_votes ? "true" : "",
      page: state.page,
      page_size: 20,
    };
    try {
      const page = state.q ? await api.search(params) : await api.propositions({ ...params, sort: "recent" });
      if (!isCurrent()) return;
      footer(page.total, false);
      if (!page.items?.length) {
        results.innerHTML = `<div class="empty-card">Nenhum resultado${state.q ? ` para “${escapeHtml(state.q)}”` : ""}.</div>`;
        return;
      }
      results.innerHTML = `<ul class="card-grid">${page.items.map((p) => renderPropositionCard(p)).join("")}</ul>${renderPagination(page)}`;
      bindPagination(results, (n) => {
        state.page = n;
        load();
      });
    } catch (err) {
      if (!isCurrent()) return;
      footer(null, false);
      results.innerHTML = errorBanner(err);
    }
  }

  await load();
}
